import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mo_modal_l = _resolveComponent("Mo_modal_l")!

  return (_openBlock(), _createBlock(_component_Mo_modal_l, { ref: "modal_insurance" }, {
    title: _withCtx(() => _cache[1] || (_cache[1] = [
      _createTextVNode("マップ")
    ])),
    body: _withCtx(() => _cache[2] || (_cache[2] = [
      _createElementVNode("div", {
        class: "panel-container show",
        id: "panel-body"
      }, [
        _createElementVNode("div", { class: "loader" }, [
          _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
        ]),
        _createElementVNode("div", { class: "row" }, [
          _createElementVNode("div", { id: "map" })
        ])
      ], -1)
    ])),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary waves-effect waves-themed",
        "data-dismiss": "modal",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
      }, " 閉じる ")
    ]),
    _: 1
  }, 512))
}